import { useState, useEffect, useCallback } from 'react';
import { NFLGame } from '@/types';
import { getNFLWeekGames } from '@/services/api/nfl';
import { LEAGUE_REFRESH_INTERVALS } from '@/constants/leagues';
import { livePoller } from '@/services/livePoller';

export function useNFLGames() {
  const [games, setGames] = useState<NFLGame[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const hasLive = games.some((g) => g.status === 'live');
  const refreshInterval = hasLive
    ? LEAGUE_REFRESH_INTERVALS.live
    : LEAGUE_REFRESH_INTERVALS.idle;

  const fetch = useCallback(async () => {
    try {
      const data = await getNFLWeekGames();
      setGames(data);
      setLastUpdated(new Date());
      setError(null);
      livePoller.notifyGameUpdates(data).catch(() => {});
    } catch (e: any) {
      setError(e.message ?? 'Erro ao buscar jogos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
    const timer = setInterval(fetch, refreshInterval);
    return () => clearInterval(timer);
  }, [fetch, refreshInterval]);

  const liveGames = games.filter((g) => g.status === 'live');
  const scheduledGames = games.filter((g) => g.status === 'scheduled');
  const finishedGames = games.filter((g) => g.status === 'finished');

  return { games, liveGames, scheduledGames, finishedGames, loading, error, refresh: fetch, lastUpdated };
}
